export const AlineacionHorizontal = {
    IZQUIERDA: "IZQUIERDA",
    DERECHA: "DERECHA",
    CENTRO: "CENTRO"
};